// frontend/src/Components/SyncTo/helpers/mimePicker.js
// Phase 30 — pickMimeType() + mimeToExt().
// Source cascade: .planning/research/STACK.md:131-143 (verbatim)
// Contract: pickMimeType() returns null on browsers without MediaRecorder →
//           SyncToButton D-02 disabled+tooltip branch.

const PREFERRED_MIME_TYPES = [
  'audio/webm;codecs=opus',      // Chrome/Edge/Firefox desktop + Android
  'audio/ogg;codecs=opus',       // Firefox historical
  'audio/mp4;codecs=mp4a.40.2',  // Safari 14.1+ (AAC)
  'audio/webm',                  // Bare webm fallback
  'audio/mp4',                   // Bare mp4 fallback
];

export function pickMimeType() {
  if (typeof MediaRecorder === 'undefined') return null;
  return PREFERRED_MIME_TYPES.find((t) => MediaRecorder.isTypeSupported(t)) || null;
}

export function mimeToExt(mime) {
  if (!mime) return '.bin';
  if (mime.startsWith('audio/webm')) return '.webm';
  if (mime.startsWith('audio/ogg'))  return '.ogg';
  if (mime.startsWith('audio/mp4'))  return '.mp4';
  return '.bin';
}
